import { z } from 'zod';
import { STAFF_ROLES } from './platform.js';
/** Equipe da clínica, gerida pelo painel (Configurações → Equipe). */
export const teamMemberSchema = z.object({
    userId: z.uuid(),
    name: z.string(),
    email: z.string(),
    roles: z.array(z.enum(STAFF_ROLES)),
    /** invited = ainda não criou a senha; disabled = acesso a esta clínica desativado */
    status: z.enum(['invited', 'active', 'disabled']),
    mfaEnrolled: z.boolean(),
    lastLoginAt: z.string().nullable(),
    isYou: z.boolean(),
});
export const inviteMemberSchema = z.object({
    email: z.string().trim().toLowerCase().max(254).pipe(z.email('Informe um e-mail válido')),
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    role: z.enum(STAFF_ROLES),
});
export const updateMemberSchema = z.object({ role: z.enum(STAFF_ROLES) });
/** `inviteSent`: false quando a pessoa já tinha conta (só ganhou acesso a esta clínica). */
export const inviteMemberResponseSchema = z.object({ member: teamMemberSchema, inviteSent: z.boolean() });
//# sourceMappingURL=team.js.map